// services/everpro/everpro-order/fetchAll.ts — tarik SEMUA halaman order Everpro (loop pagination)
import { fetchEverproOrders } from './list.js';
import type { EverproOrderListParams } from './list.js';
import type { EverproOrderListRow } from '../everpro-types';

const LIMIT = 50;
const PAGE_DELAY_MS = 200; // jeda antar halaman — hindari rate-limit Everpro

/**
 * Loop pagination 50/halaman. Metadata API (pagination.total/last_page) TIDAK BISA DIPERCAYA
 * (total=16, last_page=1 padahal ada 798 order — terverifikasi 2026-08-15) → berhenti saat
 * halaman "pendek" (items < limit) atau kosong. Dedup by AWB.
 */
export async function fetchAllEverproOrders(
  brandIds: string[],
  params: EverproOrderListParams,
  onProgress?: (loaded: number) => void,
): Promise<EverproOrderListRow[]> {
  const seen = new Set<string>();
  const rows: EverproOrderListRow[] = [];
  for (const brandId of brandIds) {
    let page = 1;
    for (let guard = 0; guard < 500; guard++) {
      const data = await fetchEverproOrders({ ...params, page, limit: LIMIT }, brandId);
      const items = data.orders;
      if (!items.length) break;
      for (const o of items) {
        const key = `${brandId}:${o.awbNumber || o.shipmentOrderNo}`;
        if (seen.has(key)) continue;
        seen.add(key);
        rows.push({ ...o, brandId });
      }
      onProgress?.(rows.length);
      if (items.length < LIMIT) break;
      page += 1;
      await new Promise(r => setTimeout(r, PAGE_DELAY_MS));
    }
  }
  return rows;
}
